import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";

export const FarmStickyBar = ({ onOpen }) => {
  const { t } = useLang();
  return (
    <motion.div
      data-testid="farm-sticky-bar"
      initial={{ y: 96 }}
      animate={{ y: 0 }}
      transition={{ delay: 1.0, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-0 inset-x-0 z-40 border-t border-[#1A2A24] bg-[#0E1613]/85 backdrop-blur-md"
    >
      <div
        className="mx-auto w-full max-w-[480px] px-4 pt-3"
        style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      >
        <button
          type="button"
          data-testid="farm-sticky-whatsapp"
          onClick={onOpen}
          className="h-14 w-full bg-[#B8894B] text-[#0E1613] font-mono-label text-xs tracking-[0.2em] uppercase active:bg-[#EDE7DA] transition-colors duration-200 flex items-center justify-center gap-2"
        >
          {t("fh.cta")}
          <ArrowUpRight className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
};
